import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../../api';

export const fetchAnalyticsOverview = createAsyncThunk('analytics/fetchOverview', async () => {
    return await apiRequest('/api/v1/analytics/overview');
});

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState: {
        overview: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnalyticsOverview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAnalyticsOverview.fulfilled, (state, action) => {
                state.loading = false;
                state.overview = action.payload;
            })
            .addCase(fetchAnalyticsOverview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default analyticsSlice.reducer; 